import { Component, OnInit, HostListener } from '@angular/core';
import { DiscardJobInputDocument } from 'src/app/models/job';
import { ApiService, ABCisApi } from 'src/app/handlers/apiHandler.service';
import { ToastrService } from 'ngx-toastr';
import { OcrJob, OcrChannel, HttpStatus } from 'src/app/constants/constants';
import { HttpErrorResponse } from '@angular/common/http';
import { ConfigurationPage } from '../ConfigurationPage';

@Component({
  selector: 'app-discard-job',
  standalone: false,
  templateUrl: './discard-job.component.html',
  styleUrls: ['./discard-job.component.scss']
})
export class DiscardJobComponent implements OnInit, ConfigurationPage {

  currentInputDocument: DiscardJobInputDocument;
  isloading: boolean = false;
  pdfWidth: number = null;

  constructor(private apiHandler: ApiService, private toastr: ToastrService) { }

  ngOnInit() {
  }

  getNextFile() {
    this.isloading = true;
    const request = this.apiHandler.getABCisRequest<DiscardJobInputDocument>(ABCisApi.Ocr, `job/${OcrJob.OCR_DISCARD}/next-document?channelId=${OcrChannel.WEB_UI}`);
    request.then(httpResponse => {
      if (httpResponse.status == HttpStatus.NO_CONTENT) {
        this.currentInputDocument = undefined;
        this.toastr.info('No more files available for Discard job');
      } else {
        this.currentInputDocument = httpResponse.body;
      }
      this.isloading = false;
    })
      .catch((response: HttpErrorResponse) => {
        this.toastr.error(response.error);
        this.isloading = false;
      });
  }

  @HostListener('window:beforeunload', ['$event'])
  OnClose($event) {
    if(this.currentInputDocument !== undefined) $event.returnValue = 'Are you sure you want to leave?';
  }

  /**
   * This gets called when routing away from page
   */
  ReleaseDocument() {
    this.releaseFile();
  }

  releaseFile() {
    this.isloading = true;
    const request = this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument.uuid}/release`);
    request.then((val) => {
      this.currentInputDocument = undefined;
      this.isloading = false;
    })
      .catch((response: HttpErrorResponse) => {
        this.toastr.error(response.error);
        this.isloading = false;
      });
  }

  onDiscardClick() {
    this.isloading = true;
    const request = this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument.uuid}/user-discard`);
    request.then((val) => {
      this.getNextFile();
    })
      .catch((response: HttpErrorResponse) => {
        this.toastr.error(response.error);
        this.isloading = false;
      });
  }

  onRestoreClick() {
    this.isloading = true;
    const request = this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument.uuid}/redo-category-in-web`);
    request.then((val) => {
      this.getNextFile();
    })
      .catch((response: HttpErrorResponse) => {
        this.toastr.error(response.error);
        this.isloading = false;
      });
  }

  changePdfWidth(num) {
    this.pdfWidth = num;
  };

  onAllocateClick() {
    this.isloading = true;
    const request = this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument.uuid}/to-allocator`);
    request.then((val) => {
      this.getNextFile();
    })
      .catch((response: HttpErrorResponse) => {
        this.toastr.error(response.error);
        this.isloading = false;
      });
  }
}
